export type WorkspacePreset = 'simple' | 'full'

/** Paneles con datos reales disponibles en Uniswap v2 on-chain */
export type WorkspacePanelId = 'reserves' | 'poolStats'

export type WorkspaceMobileTab = 'trade' | 'reserves' | 'poolStats'

export const WORKSPACE_PRESET_LABELS: Record<WorkspacePreset, string> = {
  simple: 'Simple',
  full: 'Completo',
}

export const PRESET_PANELS: Record<WorkspacePreset, WorkspacePanelId[]> = {
  simple: [],
  full: ['reserves', 'poolStats'],
}

export const PRESET_MOBILE_TABS: Record<WorkspacePreset, WorkspaceMobileTab[]> = {
  simple: ['trade'],
  full: ['trade', 'reserves', 'poolStats'],
}

export const WORKSPACE_STORAGE_KEY = 'dex-workspace-preferences'

/** Migra presets legacy (standard/pro) a full */
export function normalizeWorkspacePreset(value: unknown): WorkspacePreset {
  if (value === 'simple') return 'simple'
  if (value === 'full' || value === 'standard' || value === 'pro') return 'full'
  return 'simple'
}
